import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Thumb from './../../Thumb';
import { formatPrice } from '../../../services/util';
import { BsPlus } from 'react-icons/bs';

class CartProduct extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    removeItemFromCart: PropTypes.func.isRequired,
    updateCartItem: PropTypes.func.isRequired,
    parent: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isMouseOver: false
    };
  }

  handleMouseOver = () => {
    this.setState({ isMouseOver: true });
  };

  handleMouseOut = () => {
    this.setState({ isMouseOver: false });
  };

  handleOnIncrease = () => {
    const { updateCartItem } = this.props;
    const { product } = this.props;
    updateCartItem(this.props.parent, product, "plus");
  }

  handleOnDecrease = () => {
    const { updateCartItem } = this.props;
    const { product } = this.props;
    updateCartItem(this.props.parent, product, "minus");
  }

  render() {
    const { removeItemFromCart } = this.props;
    const { product } = this.props;

    const classes = ['shelf-item'];

    if (!!this.state.isMouseOver) {
      classes.push('shelf-item--mouseover');
    }

    return (
      <div className={classes.join(' ')}>
        <div
          className="shelf-item__del"
          onMouseOver={() => this.handleMouseOver()}
          onMouseOut={() => this.handleMouseOut()}
          onClick={() => removeItemFromCart(this.props.parent, product)}
        />
        <Thumb
          classes="shelf-item__thumb"
          src={require(`../../../static/products/${product.sku}_2.jpg`)}
          alt={product.title}
        />
        <div className="shelf-item__details">
          <p className="title">{product.title}</p>
          <p className="desc">
            {`${product.availableSizes[0]} | ${product.style}`} <br />
            Quantity: {product.quantity}
          </p>
        </div>
        <div className="shelf-item__price">
          <p>{`${product.currencyFormat}  ${formatPrice(product.price)}`}</p>
          <div>
            <button onClick={this.handleOnDecrease} disabled={product.quantity === 1 ? true : false} className="change-product-button">-</button>
            <button onClick={this.handleOnIncrease} className="change-product-button">+</button>
          </div>
        </div>
      </div>
    );
  }
}

export default CartProduct;
